import { render } from "./EmergenciesPage.vue?vue&type=template&id=261729b1&scoped=true"
import script from "./EmergenciesPage.vue?vue&type=script&lang=js"
export * from "./EmergenciesPage.vue?vue&type=script&lang=js"

import "./EmergenciesPage.vue?vue&type=style&index=0&id=261729b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261729b1"]])

export default __exports__